/* BLUETTI Power — form confirmations. GENERATED by tools/build_theme.py. */
(function () {
  'use strict';
  /* Forms. Shopify's contact and customer endpoints redirect back with
     ?contact_posted=true / ?customer_posted=true; which form on the page sent
     it is remembered across that redirect, and its confirmation is shown. */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('form[data-bp-form]');
    if (f) { try { sessionStorage.setItem('bp-sent', f.getAttribute('data-bp-form')); } catch (x) {} }
  });
  if (/[?&](contact|customer)_posted=true/.test(window.location.search)) {
    var id = null;
    try { id = sessionStorage.getItem('bp-sent'); sessionStorage.removeItem('bp-sent'); } catch (x) {}
    var note = id && document.querySelector('[data-bp-sent="' + id + '"]');
    if (note) { note.hidden = false; note.scrollIntoView({ block: 'center' }); }
  }
}());
